import React, { useEffect, useState } from "react";
import { Lock, AlertOctagon, CheckCircle2 } from "lucide-react";
import { Button } from "./ui/button";
import { supabase } from "@/integrations/supabase/client";

interface AntiFraudLockScreenProps {
  blockData: any;
  onResolved: () => void;
}

export const AntiFraudLockScreen: React.FC<AntiFraudLockScreenProps> = ({ blockData, onResolved }) => {
  const [loading, setLoading] = useState(false);
  const [mediaData, setMediaData] = useState<any>(null);

  useEffect(() => {
    const fetchMedia = async () => {
      if (blockData.media_id) {
        const { data } = await supabase.from('album_media').select('*').eq('id', blockData.media_id).single();
        if (data) setMediaData(data);
      }
    };
    fetchMedia();
  }, [blockData.media_id]);

  const handlePay = () => {
    // Redireciona para o checkout com a media_id
    if (blockData.media_id) {
      window.location.href = `/checkout?media_ids=["${blockData.media_id}"]&is_fraud_resolution=true&block_id=${blockData.id}`;
    }
  };

  return (
    <div className="fixed inset-0 z-[99999] bg-red-950 flex items-center justify-center p-4 overflow-y-auto">
      <div className="max-w-2xl w-full bg-black border border-red-500/30 rounded-3xl p-6 md:p-10 shadow-2xl shadow-red-900/20 text-center relative overflow-hidden">
        {/* Background glow */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[300px] h-[300px] bg-red-600/20 rounded-full blur-[100px] pointer-events-none" />

        <AlertOctagon className="w-16 h-16 text-red-500 mx-auto mb-6 animate-pulse" />
        
        <h1 className="text-2xl md:text-4xl font-black text-white uppercase tracking-tight mb-2">
          APARELHO BLOQUEADO
        </h1>
        <p className="text-red-400 font-medium mb-8 text-sm md:text-base">
          Motivo: Uso Indevido de Imagem Protegida (Direitos Autorais)
        </p>

        <div className="bg-red-950/50 border border-red-900/50 rounded-2xl p-6 text-left mb-8 space-y-4">
          <p className="text-gray-300 text-sm leading-relaxed">
            Identificamos que uma foto de nossa autoria foi utilizada sem a devida autorização ou pagamento. O seu acesso a este aplicativo e todas as galerias foi suspenso.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
            <div className="space-y-2">
              <span className="text-[10px] font-black uppercase text-red-400 tracking-widest">Prova do Uso Indevido</span>
              <div className="aspect-[4/5] rounded-xl overflow-hidden border border-white/10 bg-black/50 relative group">
                <img src={blockData.proof_image_url} alt="Prova" className="w-full h-full object-cover" />
              </div>
            </div>
            
            <div className="space-y-2">
              <span className="text-[10px] font-black uppercase text-red-400 tracking-widest">Foto Original</span>
              <div className="aspect-[4/5] rounded-xl overflow-hidden border border-white/10 bg-black/50 relative">
                {mediaData ? (
                  <img src={mediaData.url} alt="Original" className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    <span className="text-xs text-white/30">Carregando...</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <p className="text-white/70 text-sm">
            Para restaurar o seu acesso e desbloquear o seu aparelho, é necessário efetuar o pagamento da foto utilizada. Após o pagamento, a foto também ficará disponível na sua pasta de Fotos Compradas sem marca d'água.
          </p>

          <Button 
            size="lg" 
            onClick={handlePay}
            className="w-full bg-red-600 hover:bg-red-700 text-white font-black uppercase tracking-widest h-14 rounded-xl mt-4 flex items-center justify-center gap-2"
          >
            <Lock className="w-5 h-5" />
            PAGAR E DESBLOQUEAR ACESSO
          </Button>
          
          <p className="text-[10px] text-white/30 uppercase tracking-widest mt-6">
            Block ID: {blockData.id.split('-')[0]} • Device ID: {blockData.device_id.substring(0, 8)}
          </p>
        </div>
      </div>
    </div>
  );
};
